<template>
  <el-drawer
    v-if="visible"
    show-close
    :visible="visible"
    :size="1100"
    :title="title"
    @close="close()"
    destroy-on-close
    :append-to-body="true"
  >
    <choose-material
      ref="chooseMaterialInner"
      :productLine="productLine"
      :amzSkuMaterialGroup="amzSkuMaterialGroup"
      :type="type"
      @close="close"
      @confirm="confirm"
      @addMaterial="addMaterial"
    />
  </el-drawer>
</template>
<script>
import ChooseMaterial from './index.vue'
export default {
  components: {
    ChooseMaterial,
  },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    amzSkuMaterialGroup: { type: String, default: '' },
    productLine: { type: String, default: '' },
    type: String,
  },
  methods: {
    reloadList() {
      this.$refs.chooseMaterialInner.reloadList()
    },
    confirm() {
      const data = this.$refs.chooseMaterialInner.choiceData()
      if (!data) {
        return
      }
      this.$emit('confirm', data)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    addMaterial() {
      this.$emit('addMaterial')
    },
  },
}
</script>
